import type { AppRouteRecord } from '../types';
import { ROUTE_NAMES, ROUTE_PATHS } from '../constants';

export const reportsRoutes: AppRouteRecord[] = [
  {
    path: ROUTE_PATHS.REPORTS,
    name: ROUTE_NAMES.REPORTS,
    component: () => import('@/pages/ReportsPage.vue'),
  },
];
